import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { CASDispositionType } from '../../DispositionTypesContext/types'
import { useRemoveCasDispositionTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useDispositionTypesContext } from '../../DispositionTypesContext'

export function useRemove(): RemoveRowActionOptions<CASDispositionType> {
  const { refetch } = useDispositionTypesContext()
  const [remove] = useRemoveCasDispositionTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveCASDispositionType: {
        dispositionType: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreCASDispositionType,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
    disabled: ({ submittals }) =>
      !!submittals.length && {
        message:
          'Submittal Disposition Types cannot be deleted if they are associated with one or more Submittal',
      },
  }
}
